import type { TranslationSchema } from '../types';

export const tr: TranslationSchema = {
  nav: {
    features: 'Yetenekler',
    dlpVault: 'DLP Kasası',
    budget: 'Bütçe Yönetimi',
    analytics: 'Analitik',
    architecture: 'Mimari',
    comparison: 'Karşılaştırma',
    faq: 'SSS',
    github: 'GitHub',
    joinWaitlist: 'Bekleme Listesine Katıl',
    badge: 'Özel Beta',
    openSourceBadge: 'Açık Kaynak',
  },
  hero: {
    statusBadge: 'Özel Beta Erişimi Aylık Olarak Açılıyor',
    openSourceBadge: "GitHub'da %100 Açık Kaynak",
    titleLine1: 'Açık Kaynaklı Kurumsal Yapay Zeka Ağ Geçidi:',
    titleHighlight: 'Sıfır Güven Veri Egemenliği',
    titleLine2: 've Hassas Bütçe Yönetimi',
    description:
      'Ekiplerinizin herhangi bir LLM modelini güvenle kullanmasını sağlayın. Bellek içi DLP temizleme mekanizması, hassas verileri ve anahtarları şirket dışına çıkmadan sansürler; esnek aşım korumalı katı USD bütçe limitleri, SAML SSO ve değişmez denetim kayıtlarıyla güvenceye alır.',
    trustPoint1: 'Sıfır Depolamalı Geçici Bellek İçi Token Kasası',
    trustPoint2: 'Evrensel Çoklu Sağlayıcı Yedekleme (Fallback)',
    trustPoint3: 'Milisaniyenin Altında Edge Ağ Geçidi Yönlendirmesi',
    githubStars: "GitHub'da İncele",
  },
  waitlist: {
    inputPlaceholder: 'İş e-posta adresinizi girin...',
    ctaButton: 'Erken Erişim Talep Et',
    submitting: 'Kaydınız Alınıyor...',
    successTitle: 'Listeye başarıyla eklendiniz!',
    successMessage:
      'Özel beta bekleme listemize katıldığınız için teşekkürler. Bir sonraki aylık beta grubunda size erişim davetiyesi ileteceğiz.',
    duplicateMessage:
      'Zaten kayıtlısınız! E-postanız sistemimizde mevcut, sıradaki aylık kontenjanda sizinle iletişime geçeceğiz.',
    privacyNotice: 'Katı sıfır-spam politikası. E-postanız yalnızca beta davetleri için saklanır.',
    errorMessage: 'E-posta kaydedilemedi. Lütfen adresinizi kontrol edip tekrar deneyin.',
    statsNote: "Beta erişimi bekleyen 450'den fazla mühendislik ve güvenlik ekibine katılın",
    rolloutNotice: 'Beta davetiyeleri aylık periyotlarla gönderilmektedir.',
  },
  dlpDemo: {
    badge: 'Canlı İnteraktif Simülasyon',
    title: 'Çift Yönlü DLP Temizleme Deneyimi',
    subtitle:
      'Hassas kurumsal kimlik bilgileri ve müşteri verileri, güvenlik duvarınızdan çıkmadan önce bellek içinde kriptografik vekil tokenlere dönüştürülür, yanıtta otomatik olarak geri yüklenir.',
    samplePromptLabel: 'Örnek Hassas Veri Yükle:',
    presets: {
      card: '💳 Kredi Kartı ve Fatura Verisi',
      apiSecret: '🔑 Canlı API Anahtarı ve Gizli Token',
      pii: '👤 T.C. Kimlik No ve Personel Verisi',
    },
    rawInputLabel: '1. Kullanıcı İstemi (Şirket İçi Güvenli Alan)',
    rawInputPlaceholder: 'E-posta, kredi kartı veya API anahtarı içeren bir metin yazın...',
    sanitizedLabel: '2. Sansürlenmiş İstem (Dış LLM Sağlayıcısına İletilen)',
    sanitizedSubtext: 'Hassas veriler anlık vekil tokenler ile değiştirildi',
    restoredLabel: '3. LLM Yanıtı (Tarayıcıda / Uygulamada Geri Yüklenen)',
    restoredSubtext: 'Dinamik akış motoru orijinal bağlamı kullanıcıya kusursuzca sunar',
    vaultStatus: 'Bellek İçi Kasa Durumu: AKTİF (Uçucu, Asla Veritabanına Yazılmaz)',
    redactedBadge: 'Tespit Edildi & Sansürlendi',
    zeroStorageBadge: '%100 Sıfır Veri Sızıntısı Garantisi',
  },
  budgetSimulator: {
    badge: 'Finansal Güvenlik Sınırları',
    title: 'Hassas USD Bütçe & Esnek Aşım Motoru',
    subtitle:
      'Her takım için katı USD kotaları tanımlayın. İstek bakiyeyi az farkla aşarsa kullanıcı mağdur edilmez, yanıt tamamlanır, eksi bakiye kaydedilir ve yeni istekler bütçe yüklenene dek durdurulur.',
    teamBudgetLabel: 'Takım Aylık Bütçe Üst Limiti (USD):',
    teamBudgetSub: 'Kanonik bütçeler USD cinsindendir (min 5.00$) ve canlı kurlarla çevrilir.',
    currencyLabel: 'Gösterim Para Birimi:',
    currentBalanceLabel: 'Kalan Bakiye',
    spentLabel: 'Bu Dönem Harcanan',
    simulatePromptButton: '⚡ 0.05$ Tutarında İstek Gönder',
    simulateOverdraftButton: '🚨 Esnek Aşımı Tetikle (0.20$ İstek)',
    resetButton: 'Simülasyonu Sıfırla',
    overdraftBannerTitle: 'Esnek Aşım (Soft-Overdraft) Devrede (Eksi Bakiye Kaydedildi)',
    overdraftBannerDesc:
      'Kullanıcının işi bölünmesin diye istek tamamlandı. Bakiye eksiye düştü; bütçe yenilenene kadar yeni sorgular bloke edildi.',
    statusActive: 'AKTİF (Bütçe Dahilinde)',
    statusOverdraft: 'AŞIM BLOKESİ (Bütçe Yüklemesi Gerekli)',
    ruleMinLimit: 'Minimum Takım Bütçesi: 5.00 USD',
    ruleSoftOverdraft: 'Esnek Aşım: İsteği tamamlar, eksi bakiye yazar, yeni istekleri durdurur',
  },
  analytics: {
    badge: 'Gözlemlenebilirlik & Denetim',
    title: 'Değiştirilemez Token ve Harcama Analitiği',
    subtitle:
      'Ağ geçidinden geçen her bir token, kriptografik kullanıcı ve takım aidiyeti ile kaydedilir. OpenAI, Claude ve yerel modellerin gerçek zamanlı maliyet dökümü.',
    metrics: {
      tokens: 'İşlenen Toplam Token',
      spend: 'Aylık Model Harcaması',
      dlpBlocked: 'Sansürlenen PII Varlığı',
      latency: 'Ortalama Ağ Geçidi Gecikmesi',
    },
    liveAuditTitle: 'Append-Only Değiştirilemez Denetim Akışı',
    liveAuditSub: 'Tüm sorgu logları doğrudan PostgreSQL veri tabanına yalnızca ekleme (append-only) kuralıyla yazılır.',
    tableHeaders: {
      time: 'Zaman',
      model: 'Model / Ağ Geçidi',
      team: 'Takım / Kullanıcı',
      tokens: 'Token (Giriş/Çıkış)',
      cost: 'Maliyet (USD)',
      dlpFlag: 'DLP Aksiyonu',
    },
    modelShareTitle: 'Sağlayıcı Maliyet Dağılımı',
    immutableNotice: '%100 Append-Only Mimari: Denetim kayıtları asla değiştirilemez veya silinemez.',
  },
  features: {
    badge: 'Kurumsal Mimari',
    title: 'Güvenlik Ekipleri İçin Tasarlandı, Mühendislerin Tercihi',
    subtitle:
      'Haskell esintili fonksiyonel mimari, sıfır veri sızıntısı ve tavizsiz finansal güvenlik sınırları ile inşa edilmiş kurumsal kontrol düzlemi.',
    items: [
      {
        id: 'dlp',
        tag: 'Veri Egemenliği',
        title: 'Bellek İçi DLP Token Kasası',
        description:
          'Kurumunuza özel Seviye 2 regex kuralları, evrensel filtrelerle (kredi kartı, TC Kimlik, AWS anahtarları) eşzamanlı çalışır. Tokenler yalnızca istek süresince RAM üzerinde yaşar.',
        specs: ['Seviye 2 Kuralları Önceliklidir', 'İstemci Taraflı Akış Geri Çözücü', 'Sıfır DB / Log Sızıntısı'],
      },
      {
        id: 'budget',
        tag: 'Finansal Güvenlik',
        title: 'Hassas USD Bütçe Motoru',
        description:
          'Ekipler için USD cinsinden katı bütçeler belirleyin (minimum 5.00$). Esnek aşım (soft-overdraft) mekanizması ile son istek tamamlanır, eksi bakiye kaydedilir ve yeni harcama durdurulur.',
        specs: ['Kanonik USD Bütçeleme', 'Otomatik Yerel Para Birimi (TRY/EUR/GBP)', 'Gerçek Zamanlı Maliyet Muhasebesi'],
      },
      {
        id: 'gateway',
        tag: 'Yüksek Erişilebilirlik',
        title: 'Birleşik Yapay Zeka Ağ Geçidi',
        description:
          'Kademeli otomatik yedekleme (failover): Takım Ağ Geçidi → Kurum Ağ Geçidi → Platform Varsayılanı. Portkey, Cloudflare AI Gateway, OpenAI, Anthropic ve yerel Ollama desteği.',
        specs: ['AES-256-GCM Anahtar Şifreleme', 'Akıllı Kademeli Yedekleme', 'Gecikme & Token Analitiği'],
      },
      {
        id: 'rag',
        tag: 'Kurumsal Bilgi Bankası',
        title: 'Asenkron Ayrıştırıcı & RAG Motoru',
        description:
          'Haskell Parsec doküman ayrıştırıcı mikroservisi; PDF, DOCX ve Markdown dosyalarını arka planda AST yapısına dönüştürür. Vektörler Qdrant üzerinde kurum bazında tam izoledir.',
        specs: ['%100 Asenkron Kuyruk İşleme', 'Doğrudan R2/S3 İmzalı Yükleme', 'Katı Kurumsal Vektör İzolasyonu'],
      },
      {
        id: 'iam',
        tag: 'Kimlik & Denetim',
        title: 'Kurumsal IAM ve Denetim İzi',
        description:
          'NextAuth v5 ile SAML Jackson, LDAP ve OAuth entegrasyonu; giriş sonrası çok kiracılı kurum seçici. Tüketilen her token için değişmez denetim kayıtları.',
        specs: ['SAML 2.0 & LDAP Desteği', 'Giriş Sonrası Kurum Seçimi', 'Değiştirilemez Denetim Günlüğü'],
      },
      {
        id: 'deployment',
        tag: 'Esnek Dağıtım',
        title: 'Cloudflare SaaS veya Kendi Sunucunuzda',
        description:
          'İster Cloudflare Pages + Tunnel + R2 üzerinde uç nokta SaaS olarak çalıştırın, ister şirket içi Docker Compose ortamında tamamen izole yayınlayın.',
        specs: ['Sıfır Güven Cloudflare Tunnel', 'Docker Compose Tek Kiracılı Mod', 'PostgREST Uç Nokta DB Katmanı'],
      },
      {
        id: 'connectors',
        tag: 'Genişletilebilirlik',
        title: 'Konektör Eklentileri & WAP Protokolü',
        description:
          'Standart Workouse Eylem Protokolü (WAP) ile Paraşüt e-fatura, CRM sistemleri ve harici OpenAPI 3.0 REST uç noktalarıyla güvenli veri entegrasyonu.',
        specs: ['Workouse Action Protocol (WAP)', 'Hazır Paraşüt & CRM Eklentileri', 'OpenAPI 3.0 Otomatik Entegrasyon'],
      },
      {
        id: 'sandbox',
        tag: 'Güvenli Yürütme',
        title: 'İzole V8 Sandbox & Kayıtlı İş Akışları',
        description:
          'Yapay zeka komut dosyalarını izole Cloudflare V8 / Deno sandboxlarında çalıştırın. İki aşamalı simülasyon ile durum değiştiren işlemler önce görsel diff olarak onayınıza sunulur.',
        specs: ['İzole Cloudflare V8 / Deno', 'İki Aşamalı HITL Önizleme (Diff)', 'Kayıtlı İş Akışları & Slash Komutları'],
      },
      {
        id: 'secrets',
        tag: 'Otoriter Güvenlik',
        title: 'Otoriter Gizli Anahtar Mimarisi',
        description:
          'Sıfır ham anahtar sızıntısı. Şirket içi ortamda HashiCorp Vault, bulutta Cloudflare Secrets ile modeller ve sandboxlar şifrelenmemiş anahtarlara asla doğrudan erişemez.',
        specs: ['HashiCorp Vault & Cloudflare Secrets', 'Sıfır Ham Anahtar Girişi', 'Broker Vekil Çıkışı'],
      },
    ],
  },
  architecture: {
    badge: 'Veri Akış Topolojisi',
    title: 'Workouse AI Şirketinizi Nasıl Korur?',
    subtitle:
      'Gerçek kurumsal veriler yalnızca sizin PostgreSQL alanınızda kalır. Dış ağa yalnızca geçici vekil tokenler çıkar.',
    step1Title: '1. Kullanıcı İstemi Gönderilir',
    step1Desc: 'Çalışan, sohbet arayüzü veya API üzerinden SAML doğrulaması ile komutunu girer.',
    step2Title: '2. Bellek İçi DLP Temizleme',
    step2Desc: 'Geçici Token Kasası hassas verileri algılar ve anında vekil tokenlere ({{TAG_N}}) dönüştürür.',
    step3Title: '3. Şifreli Ağ Geçidi Çıkışı',
    step3Desc: 'Sansürlenmiş güvenli istek AI Ağ Geçidi üzerinden OpenAI, Anthropic veya Cloudflare AI modeline iletilir.',
    step4Title: '4. Dinamik Yanıt Çözümleme',
    step4Desc: 'LLM yanıtı akarken istemci tarafında anında çözümlenir ve tokenler bellekten silinir.',
    securityNote: 'Dış model sağlayıcılarına hiçbir PII verisi ulaşmaz. Gizli anahtarlar diske yazılmaz.',
  },
  comparison: {
    badge: 'Kurumsal Karşılaştırma',
    title: 'Doğrudan LLM Abonelikleri Neden Yetersiz Kalır?',
    subtitle:
      'Workouse AI’ın kurumsal güvenlik, denetim ve bütçe kontrolünde sağladığı üstünlükleri inceleyin.',
    headers: {
      feature: 'Özellik / Yetenek',
      direct: 'Doğrudan LLM Hesapları',
      genericWrapper: 'Standart AI Arayüzleri',
      workouse: 'Workouse AI Ağ Geçidi',
    },
    rows: [
      {
        feature: 'Bellek İçi Çift Yönlü DLP Sansürleme',
        direct: 'Yok (Tam Veri Sızıntısı)',
        genericWrapper: 'Basit regex / Veritabanında saklanır',
        workouse: 'Uçucu Bellek İçi Token Kasası (Sıfır Sızıntı)',
        highlight: true,
      },
      {
        feature: 'Takım Bütçe & Aşım Kontrolü',
        direct: 'Yalnızca genel hesap limiti',
        genericWrapper: 'Manuel aylık faturalandırma',
        workouse: 'Atomik USD Limitleri + Esnek Aşım Koruması',
        highlight: true,
      },
      {
        feature: 'Çoklu Model ve Ağ Geçidi Yönlendirme',
        direct: 'Tek sağlayıcıya bağımlılık',
        genericWrapper: 'Sabit model listesi',
        workouse: 'Portkey + Cloudflare + Doğrudan + Ollama',
      },
      {
        feature: 'Kurumsal SSO & IAM',
        direct: 'Pahalı kurumsal ek paketler',
        genericWrapper: 'Yalnızca E-posta / Şifre',
        workouse: 'SAML 2.0, LDAP ve Giriş Sonrası Kurum Seçimi',
      },
      {
        feature: 'Kendi Sunucunda / İzole Dağıtım',
        direct: 'Mümkün Değil',
        genericWrapper: 'Yalnızca Bulut',
        workouse: 'Eksiksiz Docker Compose İzole Paket',
      },
      {
        feature: 'Değiştirilemez Token & Harcama Kaydı',
        direct: 'Temel API geçmişi',
        genericWrapper: 'Basit gösterge paneli',
        workouse: 'Kriptografik ve İmmutable Denetim İzi',
      },
    ],
  },
  cta: {
    badge: 'Ayrıcalıklı Özel Beta',
    title: 'Şirketinizin Yapay Zeka Süreçlerini Bugün Güvenceye Alın',
    description:
      'Güvenlik ve bütçe endişesi olmadan üretken yapay zekayı devreye alan öncü teknoloji, finans ve sağlık ekiplerine katılın.',
    button: 'Bekleme Listesine Katıl',
    disclaimer: 'Kredi kartı gerekmez. Erken erişim davetiyeleri aylık gruplar halinde dağıtılmaktadır.',
    githubButton: "GitHub'da Keşfet",
  },
  faq: {
    badge: 'Sıkça Sorulan Sorular',
    title: 'Aklınıza Takılan Tüm Sorular',
    subtitle: 'Dağıtım, güvenlik ve aylık özel beta süreci hakkında merak edilenler.',
    items: [
      {
        question: 'Workouse AI açık kaynaklı mı?',
        answer:
          'Evet! Workouse AI açık çekirdekli (open-core) ve tamamen şeffaftır. Temel yapay zeka ağ geçidi, bellek içi DLP tokenizasyon modülü ve bütçe motoru GitHub üzerinde açıktır (github.com/workouse). Şirket içi Docker Compose üzerinde veya Cloudflare edge platformunda çalıştırabilirsiniz.',
      },
      {
        question: 'DLP Token Kasası model sağlayıcılarına veri sızıntısını nasıl engeller?',
        answer:
          'İstek şirket ağından çıkmadan önce, bellek içi ayrıştırıcımız Seviye 1 (kredi kartı, TC Kimlik, API anahtarı) ve Seviye 2 (kuruma özel regex) kuralları ile istemi tarar. Eşleşen tüm hassas metinler {{CREDIT_CARD_1}} gibi geçici tokenlere dönüştürülür. Bu eşleşme yalnızca istek süresince RAM üzerinde tutulur ve yanıt çözümlendikten hemen sonra bellekten silinir.',
      },
      {
        question: 'Workouse AI tamamen şirket içi (on-premises) sunucularımızda çalışabilir mi?',
        answer:
          'Evet! Workouse AI iki dağıtım modunu destekler: Mod A, özel VPC veya kapalı devre ağlar için Docker Compose tabanlı tek kiracılı kurulumdur. Mod B ise yüksek performanslı Cloudflare Pages + Tunnel + R2 çok kiracılı SaaS modelidir.',
      },
      {
        question: 'Bütçe esnek aşım (soft-overdraft) koruması nasıl çalışır?',
        answer:
          'Takımlara kanonik USD bütçeleri atanır (minimum 5.00$). Bir kullanıcının başlattığı sorgu kalan bakiyeyi az farkla aşarsa (örneğin 0.05$ kalmışken 0.20$ tutarsa), sistem isteğin yarım kalmaması için yanıtın tamamlanmasına izin verir, bakiyeyi eksi olarak (-0.15$) kaydeder ve bütçe yüklenene kadar sonraki istekleri durdurur.',
      },
      {
        question: 'Hangi LLM sağlayıcıları ve ağ geçitleri destekleniyor?',
        answer:
          'Workouse AI; Portkey AI Gateway, Cloudflare AI Gateway, doğrudan API’ler (OpenAI, Anthropic, Google Gemini) ve şirket içinde çalışan açık kaynak modeller (Ollama / vLLM) ile doğrudan entegre çalışır.',
      },
      {
        question: 'Özel beta davetiyeleri ne sıklıkla gönderilmektedir?',
        answer:
          'Başvurular aylık periyotlarla değerlendirilip toplu gruplar halinde davet edilmektedir. Takım çalışması ve kurumsal veri güvenliği ihtiyacı olan kurumsal e-posta adreslerine öncelik tanınmaktadır.',
      },
    ],
  },
  seo: {
    title: 'Workouse AI Gateway — Sıfır Güven Kurumsal Yapay Zeka Ağ Geçidi & DLP Kasası',
    description:
      'Workouse AI ile kurumsal yapay zeka güvenliğini sağlayın: Gerçek zamanlı RAM DLP token kasası, USD bütçe limitleri ve birleşik çoklu model yönlendirme. Aylık özel beta grubuna katılın.',
    keywords:
      'Yapay Zeka Ağ Geçidi, Kurumsal Yapay Zeka, Veri Sızıntısı Önleme, DLP Tokenizasyonu, LLM Proxy, AI Maliyet Kontrolü, Veri Egemenliği, Açık Kaynak AI Gateway, OpenAI Proxy',
    ogTitle: 'Workouse AI Gateway — Sıfır Güven Kurumsal Yapay Zeka Ağ Geçidi',
    ogDescription:
      'Kurumsal veri egemenliği, geçici RAM DLP tokenizasyonu ve USD bütçe güvenlik sınırları. Kendi sunucunuzda veya bulutta çalışır.',
  },
  footer: {
    tagline: 'Sıfır Güven Veri Egemenliğine Sahip Açık Kaynaklı Kurumsal Yapay Zeka Ağ Geçidi.',
    dataSovereignty: 'Kurumsal Güvenlik • ISO 27001 / SOC 2 Uyumlu Mimari',
    openSourceNote: "github.com/workouse adresinde %100 Açık Kaynak",
    rights: 'Tüm hakları saklıdır.',
    links: {
      architecture: 'Mimari',
      github: 'GitHub',
      docs: 'Dokümantasyon',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Koşulları',
    },
  },
};

